import store from './store'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve({ x: 0, y: 0 }), 300)
    })
  },
  routes: [
    {
      path: '/',
      component: async () => {
        const config = await store.dispatch('getConfig')
        return config.featureFlags['HOME_RASPADINHA'] ? import('./pages/HomeRaspadinha.vue') : import('./pages/Home.vue')
      }
    },
    {
      path: '/',
      component: () => import('./layouts/AppBarLayout.vue'),
      children: [
        {
          path: 'cursos',
          component: () => import('./pages/Cursos.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            if (config.featureFlags['EXIBIR_MENU_CURSOS']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'regulamento',
          component: () => import('./pages/Regulamento.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            console.log(from)
            if (config.featureFlags['EXIBIR_MENU_REGULAMENTO']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'cadastrar',
          component: () => import('./pages/Cadastrar.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            console.log(from)
            if (config.featureFlags['EXIBIR_MENU_CADASTRAR']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'ganhadores',
          component: () => import('./pages/Ganhadores.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            if (config.featureFlags['EXIBIR_MENU_GANHADORES']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'contato',
          component: () => import('./pages/Contato.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            if (config.featureFlags['EXIBIR_MENU_CONTATO']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'numero-da-sorte',
          component: () => import('./pages/NumeroDaSorte.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            if (config.featureFlags['EXIBIR_MENU_NUMEROSORTE']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'consultar-raspadinha',
          component: () => import('./pages/ConsultarRaspadinha.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            if (config.featureFlags['EXIBIR_MENU_CONSULTAR_RASPADINHA']) {
              next()
              return
            }
            next('/')
          }
        },
        {
          path: 'lojas',
          component: () => import('./pages/Lojas.vue'),
          beforeEnter: async (to, from, next) => {
            const config = await store.dispatch('getConfig')
            if (config.featureFlags['EXIBIR_MENU_LOJA']) {
              next()
              return
            }
            next('/')
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
